import React, { createContext, useEffect, useReducer } from 'react';
import { addressReducer } from './reducer';
import { useSearchParams } from '../../../../shared/lib/searchParams';
import { changeHouse, changeStreet } from './actionTypes';

export const StreetStateContext = createContext();
export const HouseStateContext = createContext();
export const AddressDispatchContext = createContext();

const initialState = {
  street: undefined,
  house: undefined,
};

export const AddressProvider = ({ children }) => {
  const [state, dispatch] = useReducer(addressReducer, initialState);
  const [searchParams] = useSearchParams();

  const streetParam = searchParams.get('street');
  const houseParam = searchParams.get('house');

  useEffect(() => {
    const param = streetParam || undefined;
    if (param !== state.street) {
      dispatch({ type: changeStreet, payload: streetParam || undefined });
    }
  }, [streetParam]);

  useEffect(() => {
    const param = houseParam || undefined;
    if (param !== state.house) {
      dispatch({ type: changeHouse, payload: houseParam || undefined });
    }
  }, [houseParam]);

  return (
    <StreetStateContext.Provider value={state.street}>
      <HouseStateContext.Provider value={state.house}>
        <AddressDispatchContext.Provider value={dispatch}>
          {children}
        </AddressDispatchContext.Provider>
      </HouseStateContext.Provider>
    </StreetStateContext.Provider>
  );
};
